import { useState, useEffect } from "react";

function App() {
  const [todos, setTodos] = useState([]);
  const [input, setInput] = useState("");
  const [filter, setFilter] = useState("all"); // all | completed | uncompleted

  // Load todos & filter dari localStorage saat pertama kali render
  useEffect(() => {
    const savedTodos = JSON.parse(localStorage.getItem("todos")) || [];
    const savedFilter = localStorage.getItem("filter") || "all";
    setTodos(savedTodos);
    setFilter(savedFilter);
  }, []);

  // Simpan todos ke localStorage setiap kali berubah
  useEffect(() => {
    localStorage.setItem("todos", JSON.stringify(todos));
  }, [todos]);

  // Simpan filter juga
  useEffect(() => {
    localStorage.setItem("filter", filter);
  }, [filter]);

  // Filter logic
  const filteredTodos = todos.filter((todo) => {
    if (filter === "completed") return todo.completed;
    if (filter === "uncompleted") return !todo.completed;
    return true;
  });

  // Tambah todo
  const addTodo = () => {
    if (input.trim() === "") return;
    setTodos([...todos, { id: Date.now(), text: input, completed: false }]);
    setInput("");
  };

  // Toggle selesai
  const toggleTodo = (index) => {
    setTodos(
      todos.map((todo, i) =>
        i === index ? { ...todo, completed: !todo.completed } : todo
      )
    );
  };

  // Hapus todo
  const deleteTodo = (index) => {
    setTodos(todos.filter((_, i) => i !== index));
  };

  // Hapus semua
  const clearTodos = () => {
    setTodos([]);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-white p-6 rounded-2xl shadow-xl max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-4">Todo App</h1>

        {/* Input */}
        <div className="flex mb-4">
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="border p-2 flex-grow rounded-l-lg outline-none"
            placeholder="Add a new todo..."
          />
          <button
            onClick={addTodo}
            className="bg-blue-500 text-white px-4 rounded-r-lg hover:bg-blue-600"
          >
            Add
          </button>
        </div>

        {/* Filter */}
        <div className="flex gap-2 mb-4 justify-center">
          <button
            onClick={() => setFilter("all")}
            className={`px-3 py-1 rounded-lg ${
              filter === "all" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
          >
            All
          </button>
          <button
            onClick={() => setFilter("uncompleted")}
            className={`px-3 py-1 rounded-lg ${
              filter === "uncompleted"
                ? "bg-blue-500 text-white"
                : "bg-gray-200"
            }`}
          >
            Uncompleted
          </button>
          <button
            onClick={() => setFilter("completed")}
            className={`px-3 py-1 rounded-lg ${
              filter === "completed" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
          >
            Completed
          </button>
        </div>

        {/* List */}
        <ul className="space-y-2">
          {filteredTodos.map((todo, idx) => {
            const originalIndex = todos.findIndex((t) => t.id === todo.id);
            return (
              <li
                key={todo.id}
                className={`p-2 rounded-lg flex justify-between items-center ${
                  todo.completed
                    ? "bg-green-100 line-through text-gray-500"
                    : "bg-gray-100"
                }`}
              >
                <span
                  className="cursor-pointer flex-grow"
                  onClick={() => toggleTodo(originalIndex)}
                >
                  {todo.text}
                </span>
                <button
                  onClick={() => deleteTodo(originalIndex)}
                  className="ml-2 bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                >
                  X
                </button>
              </li>
            );
          })}
        </ul>

        {/* Clear All */}
        {todos.length > 0 && (
          <button
            onClick={clearTodos}
            className="mt-4 w-full bg-red-600 text-white py-2 rounded-lg hover:bg-red-700"
          >
            Clear All
          </button>
        )}
        <p className="text-xs mt-2 font-medium text-slate-500"><span className="text-red-400">*</span>Todo only saved in browser</p>
      </div>
    </div>
  );
}

export default App;
